import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Injector } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, FormControl, ValidationErrors, Validators, ValidatorFn, AbstractControl } from "@angular/forms";

import { User } from 'src/app/model/user';

import { BaseComponent } from '../../common/BaseComponent';
import { ProgressService } from 'src/app/service/ProgressService';
import { UserRoleDetails } from 'src/app/model/userRoleDetails';
import { AdminService } from 'src/app/service/admin/AdminService';
import { UserRole } from 'src/app/model/userRole';
import { UserService } from 'src/app/service/UserService';


@Component({
  selector: 'app-manage-role-memship',
  templateUrl: './manage-role-memship.component.html',
  styles: [
  ]
})
export class ManageRoleMemshipComponent extends BaseComponent implements OnInit {
  @ViewChild('pageMsg') pageMsgElement: ElementRef;
  @ViewChild('progressDialog') progressDialogElementRef!: ElementRef<HTMLDialogElement>;

  restSub: Subscription;
  manageRoleForm: FormGroup;
  appErrorPrefix: string = "bss.api.error";
  userRoleDetails: UserRoleDetails;
  pageMsgRendered: boolean;
  user: User;
  roles: string;
  sendEmailBtnDisabled: boolean = true;
  successType: string;
  sendEmailType: string;

  constructor(
    injector: Injector,
    public rest: AdminService,
    public restUser: UserService,
    public progressService: ProgressService,
    public fb: FormBuilder) {
    super(injector);
    this.pageMsgRendered = false;
  }


  ngOnInit(): void {

    const sessionUserRole = sessionStorage.getItem("selectedUserRole");
    this.userRoleDetails = JSON.parse(sessionUserRole);
    this.user = this.userRoleDetails.user;
    this.userRoleDetails.user.operation = "";

    this.route.queryParams.subscribe(params => {
      this.successType = params['suc'];
      this.sendEmailType = params['sendE'];
      console.log("successType: " + this.successType);
      //successType can be sa(successAdd) or sr(successRevoke)
      if (this.successType === 'sa' || this.successType === 'sr') {
        this.appError = false;
        this.appSuccess = true;
      } else {
        this.appSuccess = false;
      }
    });

    this.manageRoleForm = new FormGroup({
    }, {
    });

    this.restSub = this.rest.getUserRoleDetails(this.userRoleDetails).subscribe(response => {
      if (response.result > 0) {
        this.user = new User();
        this.appError = true;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
        
      } else {
        this.appError = false;
        this.user = new User();
        this.user.firstName = response.firstName;
        this.user.lastName = response.lastName;
        this.user.displayName = response.displayName;
        this.user.email = response.email;
        this.user.roleAssignmentEmail = response.roleAssignmentEmail;
        
        this.user.roleAssigned = response.roleAssigned;
        if (this.user.roleAssigned === '1') {
          this.sendEmailBtnDisabled = false;
        }

        this.user.accountStatus = response.accountStatus;
        this.user.guid = response.guid;
        this.user.createdDate = response.creationDate;
        this.user.firstName = response.firstName;
        this.user.emailVerified = response.emailValidated;

        const roles: UserRole[] = [];
        if (response.otherRoles) {
          const rolesStr = response.otherRoles;
          rolesStr.forEach(v => {
            let role: UserRole = new UserRole();
            role.roleName = v;
            roles.push(role);
          });
        }
        this.user.roles = roles;
        this.roles = this.user.getRoles();
        this.userRoleDetails.user = this.user;
        sessionStorage.setItem("selectedUserRole", JSON.stringify(this.userRoleDetails));
      }
    }, (error) => { this.processError(error) },
      () => {
        this.progressService.close();
      });


  }

  ngAfterViewInit() {
    this.progressService.setDialog(this.progressDialogElementRef.nativeElement);
  }

  ngAfterViewChecked() {
    if (!this.pageMsgRendered && this.pageMsgElement !== undefined) {
      this.pageMsgElement.nativeElement.focus();
      this.pageMsgElement.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      this.pageMsgRendered = true;
    }
  }

  assignRole() {
    this.pageMsgRendered = false;
    this.appSuccess = false;
    this.userRoleDetails.user.operation = "1";
    sessionStorage.setItem("selectedUserRole", JSON.stringify(this.userRoleDetails));
    this.router.navigate(['secure/paadmin/confirmRequest']);
  }

  revokeRole() {
    this.pageMsgRendered = false;
    this.userRoleDetails.user.operation = "0";
    sessionStorage.setItem("selectedUserRole", JSON.stringify(this.userRoleDetails));
    this.router.navigate(['secure/paadmin/confirmRequest']);
  }

  sendWelcomeEmail() {
    this.pageMsgRendered = false;
    this.progressService.open();

    this.restSub = this.rest.sendWelcomeEmail(this.userRoleDetails).subscribe(response => {
      if (response.result == 1) {
        this.appError = true;
        this.appSuccess = false;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.successType = 'swe';
        this.appSuccessMessage = "bss.admin.manageRole.mship.message.welcomeEmail.success";
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      });
  }

  sendVerificationEmail() {
    this.pageMsgRendered = false;
    this.progressService.open();

    this.restSub = this.rest.sendVerificationEmail(this.userRoleDetails.user.email).subscribe(response => {
      if (response.result == 1) {
        this.appError = true;
        this.appSuccess = false;
        this.appErrorMessage = this.appErrorPrefix + "." + response.error_code;
      } else {
        this.appError = false;
        this.appSuccess = true;
        this.successType = 'sve';
        this.appSuccessMessage = "bss.admin.manageRole.mship.message.verificationEmail.success";
      }
    }, (error) => {
      this.processError(error);
    },
      () => {
        this.progressService.close();
      });
  }

  clearSession() {

  }

  onBack(): void {
    this.router.navigate(['secure/paadmin/selectUserAccount']);
  }
  resetPassword():void{
    this.router.navigate(['secure/paddmin/resetpassword']);
  }

  onNewSearch():void {
    this.newSearch();
  }
  
  ngOnDestroy() {
    if (this.restSub) {
      this.restSub.unsubscribe();
    }
  }
}


